export enum CoinAddedByEnum {
	PAYMENT_WEBHOOK = 'PAYMENT_WEBHOOK',
	MANUALLY = 'MANUALLY'
}
